import axios from "axios";

function obtenerLiquidacionesPorCliente(id, filtrar) {
    return axios.get(`api/liquidacion-deduccion/obtenerLiquidacionesPorCliente/${id}/${filtrar}`).then(r => r.data).catch(r => r);
}

function obtenerLiquidacionesPorClientePost(id) {
    return axios.post(`api/liquidacion-deduccion/obtenerLiquidacionesPorCliente`,
        {cliente_id: id}).then(r => r.data).catch(r => r);
}

function obtenerAnioLiquidacionesPorCliente(data) {
    return axios.post(`api/liquidacion-deduccion/obtenerAnioLiquidacionesPorCliente`, data).then(r => r.data).catch(r => r);
}

function obtenerMesLiquidacionesPorCliente(data) {
    return axios.post(`api/liquidacion-deduccion/obtenerMesLiquidacionesPorCliente`, data).then(r => r.data).catch(r => r);
}

function obtenerLiquidacionesPorClienteSoloFecha(id) {
    return axios.get(`api/liquidacion-deduccion/obtenerLiquidacionesPorClienteSoloFecha/${id}`).then(r => r.data).catch(r => r);
}

function liquidacionInfo(data) {
    return axios.post(`api/liquidacion-deduccion/liquidacionInfo`, data).then(r => r.data).catch(r => r);
}

function deduccionInfo(data) {
    return axios.post(`api/liquidacion-deduccion/deduccionInfo`, data).then(r => r.data).catch(r => r);
}

function guardarDeduccion(data) {
    return axios.post(`api/liquidacion-deduccion/guardarDeduccion`, data).then(r => r.data).catch(r => r);
}

function guardarDeduccionSinLiq(data) {
    return axios.post(`api/liquidacion-deduccion/guardarDeduccionSinLiq`, data).then(r => r.data).catch(r => r);
}

function editarDeduccionSinLiq(data) {
    return axios.post(`api/liquidacion-deduccion/editarDeduccionSinLiq`, data).then(r => r.data).catch(r => r);
}

function aplicarCuotaDeta(data) {
    return axios.post(`api/liquidacion-deduccion/aplicarCuotaDeta`, data).then(r => r.data).catch(r => r);
}

function editarCuotaDeta(data) {
    return axios.post(`api/liquidacion-deduccion/editarCuotaDeta`, data).then(r => r.data).catch(r => r);
}

function eliminarDeduccionPorAso(data) {
    return axios.post(`api/liquidacion-deduccion/eliminarDeduccionPorAso`, data).then(r => r.data).catch(r => r);
}

function eliminarLiquidacion(data) {
    return axios.post(`api/liquidacion-deduccion/eliminarLiquidacion`, data).then(r => r.data).catch(r => r);
}

function agregarFechaPagos(data) {
    return axios.post(`api/liquidacion-deduccion/agregarFechaPagos`, data).then(r => r.data).catch(r => r);
}


function deduccionSyP(data) {
    return axios.post(`api/liquidacion-deduccion/deduccionSyP`, data).then(r => r.data).catch(r => r);
}
export const cerrarDeduccionPorRetiro = (data) => {
    return axios.post('api/liquidacion-deduccion/cerrarDeduccionPorRetiro', data)
        .then(r => r.data)
        .catch(e => e.response.data);
}

function agregarObserDeduccion(data) {
    return axios.put(`api/liquidacion-deduccion/agregarObserDeduccion`, data).then(r => r.data).catch(r => r);
}


function getAsociados() {
    return axios.get('api/liquidacion-deduccion/getAsociados').then(r => r.data).catch(r => r);
}

function selectMaestros() {
    return axios.get('api/liquidacion-deduccion/selectMaestros').then(r => r.data).catch(r => r);
}



export {
    obtenerLiquidacionesPorCliente,
    liquidacionInfo,
    getAsociados,
    selectMaestros,
    guardarDeduccion,
    guardarDeduccionSinLiq,
    deduccionInfo,
    eliminarLiquidacion,
    editarDeduccionSinLiq,
    eliminarDeduccionPorAso,
    aplicarCuotaDeta,
    editarCuotaDeta,
    deduccionSyP,
    agregarObserDeduccion,
    obtenerLiquidacionesPorClienteSoloFecha,
    obtenerAnioLiquidacionesPorCliente,
    obtenerMesLiquidacionesPorCliente,
    obtenerLiquidacionesPorClientePost,
    agregarFechaPagos
}
